__turbopack_context__.v({
  "dayPicker": "3-module__Us4Oba__dayPicker",
  "drawFacts": "3-module__Us4Oba__drawFacts",
  "treesImage": "3-module__Us4Oba__treesImage",
});
